/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import api from '../../services/api';
import moment from 'moment'

import 'moment/locale/pt';
import FixedContainer from '../../components/Container';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../services/apiBase';

const JurosPassivo = () => {
  
  const [loading, setLoading] = useState(false);
  
  const exportData = (data, fileName, type) => {
    // Create a link and download the file
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  
  const downloadButton = async () => {
    try{
      //window.location.href = csv_link;
      setLoading(true);
      const responseData = await GetFetch('/financial/reports/detailed-cpr');
      console.log(responseData);
      exportData(responseData.data, 'juros_passivo.csv', 'text/csv');
      setLoading(false);
    } catch(error) { console.log(error);}
  }

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
          Gerar Relatório de Juros Passivo
        </Typography>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>

          <Button
            variant='contained'
            style={{ marginLeft: "1em" }}
            color="success"
            disabled={loading}
            onClick={() => downloadButton()}
          >
            {loading ? 'Gerando...' : 'Download CSV'}
          </Button>
        </Box>
      </Box>
    </FixedContainer>
  );

}

export default JurosPassivo;
